<script setup lang="ts">
import { previewTypes } from "~/features/python/ch2/data-types/data/dataTypes.content";
</script>

<template>
  <section class="space-y-4 rounded-3xl border border-slate-200 bg-slate-50 p-5">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Other Data Types (Coming Next)</h2>
      <p class="text-sm text-slate-600">List aur tuple ka quick preview yahan hai. Full detail Chapter 3 mein aayegi.</p>
    </div>

    <div class="grid gap-3">
      <article
        v-for="item in previewTypes"
        :key="item.id"
        class="rounded-2xl bg-white p-4 ring-1 ring-slate-200"
      >
        <h3 class="text-sm font-semibold text-slate-900">{{ item.title }}</h3>
        <p class="mt-1 text-sm text-slate-600">{{ item.explanation }}</p>
        <button type="button" class="mt-3 rounded-full bg-slate-950 px-3 py-1 text-xs font-medium text-white">
          {{ item.ctaLabel }}
        </button>
      </article>
    </div>
  </section>
</template>
